"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const layout_1 = require("../base/layout");
const DSS_1 = require("../DSS");
const DSSL007_List_1 = require("../DSS/DSSL007/DSSL007_List");
const DSTL001_1 = require("../DST/DSTL001");
const DSTL001_Submit_Detail_1 = require("../DST/DSTL001/DSTL001_Submit_Detail");
const DSTL001_Submit_View_1 = require("../DST/DSTL001/DSTL001_Submit_View");
const DSTL006_List_1 = require("../DST/DSTL006/DSTL006_List");
const DSTL007_1 = require("../DST/DSTL007");
const DSTS004_Answer_1 = require("../DST/DSTS004/DSTS004_Answer");
const DSTS004_Detail_1 = require("../DST/DSTS004/DSTS004_Detail");
const DSTS004_List_1 = require("../DST/DSTS004/DSTS004_List");
const DSTS004_Regist_1 = require("../DST/DSTS004/DSTS004_Regist");
const DSTS006_List_1 = require("../DST/DSTS006/DSTS006_List");
const DSTSL001_1 = require("../DST/DSTSL001");
const DSTSL001_Detail_1 = require("../DST/DSTSL001/DSTSL001_Detail");
const DSTSL001_Regist_1 = require("../DST/DSTSL001/DSTSL001_Regist");
const DSTT001_1 = require("../DST/DSTT001");
const DSTT007_1 = require("../DST/DSTT007");
const DSTT007_List_1 = require("../DST/DSTT007/DSTT007_List");
const action_1 = require("./action");
const function_1 = require("./function");
const SendSMSRegist_1 = require("../DST/DSTL007/DSTL007_Send_Child/SendSMSRegist");
const MenuBody = ({ isTeacher }) => {
    const { depths: name, menu, id, props, } = (0, react_redux_1.useSelector)((state) => (0, function_1.getMenuData)(state), react_redux_1.shallowEqual);
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const historyStore = (0, GlobalStateProvider_1.useHistoryStore)();
    (0, react_1.useEffect)(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [name, menu]);
    (0, react_1.useEffect)(() => {
        if (name === 'home')
            dispatch((0, action_1.changeMobileMenuName)(''));
        else {
            let changeMenu = `menu.${menu.menu}`;
            if (menu.menu === 'reservation' && !isTeacher) {
                dispatch((0, action_1.changeMobileMenuName)(t('menu.liveRoom')));
                return;
            }
            switch (menu.detail) {
                case 'answer':
                case 'answer_modify':
                    return;
                case 'send':
                    changeMenu = 'menu.sendToSMS';
                    break;
                case 're_regist':
                    changeMenu = `menu.qnaRequestion`;
                    break;
                case 'modify':
                    changeMenu = `menu.${menu.menu}Modify`;
                    break;
                case 'regist':
                    if (menu.menu === 'qna')
                        return;
                    changeMenu = `menu.${menu.menu}Regist`;
                    break;
                case 'question_list':
                    changeMenu = 'menu.qnaRequestionList';
                    break;
                case 'detail':
                    switch (menu.menu) {
                        case 'reservation':
                            changeMenu = 'menu.reservationDetail';
                            break;
                        case 'previous-conference':
                            changeMenu = 'menu.previousReservationDetail';
                            break;
                        case 'attendanceStatus':
                            changeMenu = isMobile ? props?.title : 'menu.attendanceStatus';
                            break;
                        default:
                            return;
                    }
            }
            dispatch((0, action_1.changeMobileMenuName)(t(changeMenu)));
        }
    }, [name, menu, props, isMobile, isTablet, isDesktop]);
    (0, react_1.useEffect)(() => {
        return () => {
            if (menu.menu === 'assignment' || menu.menu === 'test') {
                const isTest = menu.menu === 'test';
                historyStore.clearHistoryForPage(isTest ? 'testListPage' : 'assignmentListPage');
            }
            if (menu.menu === 'survey') {
                historyStore.clearHistoryForPage('surveyListPage');
            }
            if (menu.menu === 'qna') {
                historyStore.clearHistoryForPage('qnaListPage');
            }
            if (menu.menu === 'notice' || menu.menu === 'resource') {
                const isResource = menu.menu === 'resource';
                historyStore.clearHistoryForPage(isResource ? 'resourcePage' : 'noticePage');
            }
        };
    }, [name, menu?.menu]);
    if (!menu?.menu)
        return null;
    if (name === 'home')
        return null;
    if (name === 'myRoom' || name === 'learningManagement') {
        if (menu.menu === 'assignment' || menu.menu === 'test') {
            const isTest = menu.menu === 'test';
            switch (menu.detail) {
                case 'list':
                    return react_1.default.createElement(DSTL001_1.DSTL001_List, { isTeacher: isTeacher, isTest: isTest });
                case 'regist':
                case 'modify':
                    return (react_1.default.createElement(DSTL001_1.DSTP001_Regist, { ...props, id: id, isTest: isTest, isTeacher: isTeacher, isModify: menu.detail === 'regist' ? false : true }));
                case 'detail':
                    if (isTeacher) {
                        return react_1.default.createElement(DSTL001_1.DSTL001_Detail, { isTest: isTest, test_id: id, props: props });
                    }
                    else {
                        return react_1.default.createElement(DSS_1.DSSL001_Detail, { isTest: isTest, test_id: id, props: props });
                    }
                case 'submit_detail_view':
                    return (react_1.default.createElement(layout_1.MobileTabLayout, { tabList: [
                            {
                                id: 2,
                                component: [react_1.default.createElement(DSTL001_Submit_View_1.DSTL001_Submit_View, { ...props, key: id })],
                            },
                        ], showPageButton: false, isSubmit: true, test_id: id }));
                case 'submit_view':
                    return (react_1.default.createElement(layout_1.MobileTabLayout, { tabList: [
                            {
                                id: 2,
                                component: [
                                    react_1.default.createElement(DSTL001_Submit_View_1.DSTL001_Submit_View, { key: id, test_id: id, ...props }),
                                ],
                            },
                        ], showPageButton: false, isSubmit: true, 
                        // previousPageList={{
                        // 	title: t('assignment.goBack'),
                        // 	menuDetail: 'detail',
                        // 	props: { mobilePage: 1 },
                        // }}
                        test_id: id }));
                case 'submit_detail':
                    return react_1.default.createElement(DSTL001_Submit_Detail_1.DSTL001_Submit_Detail, { test_id: id, isTest: isTest });
            }
        }
        else if (menu.menu === 'attendanceStatus') {
            switch (isMobile) {
                case true:
                    switch (menu.detail) {
                        case 'detail':
                            return react_1.default.createElement(DSTL006_List_1.DSTL006_List, { isTeacher: isTeacher });
                        case 'list':
                            return react_1.default.createElement(DSTL006_List_1.DSTL006_List, { isTeacher: isTeacher });
                    }
                case false:
                    return react_1.default.createElement(DSTL006_List_1.DSTL006_List, { isTeacher: isTeacher });
            }
        }
        else if (menu.menu === 'gradeCard') {
            return react_1.default.createElement(DSSL007_List_1.DSSL007_List, null);
        }
        else if (menu.menu === 'sendSMS') {
            switch (menu.detail) {
                case 'regist':
                    return react_1.default.createElement(SendSMSRegist_1.SendSMSRegist, { selectedId: id, ...props });
                case 'list':
                    return react_1.default.createElement(DSTL007_1.DSTL007_Send, { ...props, id: isMobile ? id : undefined });
            }
        }
    }
    else if (name === 'liveRoom') {
        if (menu.menu === 'reservation' || menu.menu === 'previous-conference') {
            const isClosed = menu.menu === 'reservation' ? false : true;
            switch (menu.detail) {
                case 'list':
                    return (react_1.default.createElement(DSTT001_1.DSTT001_List, { isTeacher: isTeacher, isPrevious: menu.menu === 'previous-conference', isClosed: isClosed }));
                case 'detail':
                    return (react_1.default.createElement(DSTT001_1.DSTT001_Regist, { id: id, isPrevious: menu.menu === 'previous-conference', isModify: false, isDetail: true, isTeacher: isTeacher }));
                case 'regist':
                    return react_1.default.createElement(DSTT001_1.DSTT001_Regist, { isModify: false });
                case 'modify':
                    return react_1.default.createElement(DSTT001_1.DSTT001_Regist, { isModify: true, id: id });
            }
        }
        else if (menu.menu === 'replay') {
            switch (menu.detail) {
                case 'list':
                    return react_1.default.createElement(DSTT007_List_1.DSTT007_List, { isTeacher: isTeacher });
                case 'modify':
                    return react_1.default.createElement(DSTT007_1.DSTT007_Detail, { id: id, isRegist: true, isModify: true });
                case 'regist':
                    return react_1.default.createElement(DSTT007_1.DSTT007_Detail, { id: id, isRegist: true });
                case 'detail':
                    return react_1.default.createElement(DSTT007_1.DSTT007_Detail, { id: id, isRegist: false });
            }
        }
        else if (menu.menu === 'content') {
            switch (menu.detail) {
                case 'list':
                    return react_1.default.createElement(DSTS006_List_1.DSTS006_List, null);
            }
        }
    }
    else if (name === 'notice' || name === 'learningSupportRoom') {
        if (menu.menu === 'notice') {
            switch (menu.detail) {
                case 'modify':
                    return react_1.default.createElement(DSTSL001_Regist_1.DSTSL001_Regist, { isResource: false, ...props, isTeacher: isTeacher });
                case 'regist':
                    return react_1.default.createElement(DSTSL001_Regist_1.DSTSL001_Regist, { isResource: false, ...props, isTeacher: isTeacher });
                case 'list':
                    return react_1.default.createElement(DSTSL001_1.DSTSL001_List, { isResource: false, ...props, isTeacher: isTeacher });
                case 'detail':
                    return react_1.default.createElement(DSTSL001_Detail_1.DSTSL001_Detail, { ...props, isTeacher: isTeacher });
            }
        }
        else if (menu.menu === 'resource') {
            switch (menu.detail) {
                case 'modify':
                    return react_1.default.createElement(DSTSL001_Regist_1.DSTSL001_Regist, { isResource: false, ...props, isTeacher: isTeacher });
                case 'regist':
                    return react_1.default.createElement(DSTSL001_Regist_1.DSTSL001_Regist, { isResource: true, ...props, isTeacher: isTeacher });
                case 'list':
                    return react_1.default.createElement(DSTSL001_1.DSTSL001_List, { isResource: true, ...props, isTeacher: isTeacher });
                case 'detail':
                    return react_1.default.createElement(DSTSL001_Detail_1.DSTSL001_Detail, { ...props, isTeacher: isTeacher });
            }
        }
        else if (menu.menu === 'qna') {
            switch (menu.detail) {
                case 'list':
                    return (react_1.default.createElement(DSTS004_List_1.DSTS004_List, { ...props, isTeacher: isTeacher, id: id, previousData: props }));
                case 'detail':
                    return react_1.default.createElement(DSTS004_Detail_1.DSTS004_Detail, { ...props, root_id: id });
                case 'answer':
                    return react_1.default.createElement(DSTS004_Answer_1.DSTS004_Answer, { id: id, isTeacher: isTeacher, ...props });
                case 'answer_modify':
                    return react_1.default.createElement(DSTS004_Answer_1.DSTS004_Answer, { id: id, isTeacher: isTeacher, ...props });
                case 'regist':
                    return react_1.default.createElement(DSTS004_Regist_1.DSTS004_Regist, { id: id, isTeacher: isTeacher, ...props });
                case 're_regist':
                    return isTeacher ? (react_1.default.createElement(DSTS004_Answer_1.DSTS004_Answer, { id: id, isTeacher: isTeacher, ...props })) : (react_1.default.createElement(DSTS004_Regist_1.DSTS004_Regist, { id: id, isRetry: true, isTeacher: isTeacher, ...props }));
                case 'question_list':
                    return isTeacher ? (react_1.default.createElement(DSTS004_Answer_1.DSTS004_Answer, { id: id, isTeacher: isTeacher, isPopUp: true, ...props })) : (react_1.default.createElement(DSTS004_Regist_1.DSTS004_Regist, { id: id, isTeacher: isTeacher, isPopUp: true, ...props }));
            }
        }
        else if (menu.menu === 'sendSMS') {
            switch (menu.detail) {
                case 'regist':
                    return react_1.default.createElement(SendSMSRegist_1.SendSMSRegist, { selectedId: id, ...props });
                case 'list':
                    return react_1.default.createElement(DSTL007_1.DSTL007_Send, { ...props, id: isMobile ? id : undefined });
            }
        }
        else if (menu.menu === 'survey') {
            switch (menu.detail) {
                case 'list':
                    return react_1.default.createElement(DSTL001_1.DSTL001_List, { isTeacher: isTeacher, isTest: false, isSurvey: true });
                case 'regist':
                case 'modify':
                    return (react_1.default.createElement(DSTL001_1.DSTP001_Regist, { ...props, id: id, isTest: false, isTeacher: isTeacher, isModify: menu.detail === 'modify', isSurvey: true }));
                case 'detail':
                    return isTeacher ? (react_1.default.createElement(DSTL001_1.DSTL001_Detail, { isTest: false, test_id: id, props: props, isSurvey: true })) : (react_1.default.createElement(DSS_1.DSSL001_Detail, { isTest: false, test_id: id, props: props, isSurvey: true }));
            }
        }
    }
    return react_1.default.createElement("div", null, menu?.menu);
};
exports.default = MenuBody;
